

export class CallReport {
    callReport = { data: [], PageNumber: 0, PageSize: 0, TotalCount: 0 }

    mapper(response) {
        let tempList = [];
        response?.data?.data[0]?.calls?.forEach((item) => {
            tempList.push({
                CustomerId: item?.customerId,
                PersianTime: item?.persianTime,
                FromNumber: item?.fromNumber,
                ToNumber: item?.toNumber,
                PersianConnectTime: item?.persianConnectTime,
                PersianStartTime: item?.persianStartTime,
                StartTime: item?.startTime,
                ConnectTime: item?.connectTime,
                EndTime: item?.endTime,
                Duration: item?.duration,
                DurationText: item?.durationText,
                Cost: item?.cost,
                TotalItems: item?.totalItems,
                FromContactId: item?.fromContactId,
                ToContactId: item?.toContactId,
                DownloadURL: item?.downloadURL,
                CallId: item?.callId,
                RecordingId: item?.recordingId,
                Type: item?.typeString,
                DispositionText: item?.dispositionText

            })
        })

        this.callReport.data = tempList;
        
        this.callReport.TotalDuration= response?.data?.data[0]?.totalDuration
        this.callReport.TotalDuration= response?.data?.data[0]?.totalDuration
        this.callReport.TotalFaxDuration=response?.data?.data[0]?.totalFaxDuration
        this.callReport.TotalIvrDuration =response?.data?.data[0]?.totalIvrDuration
        this.callReport.TotalMemberCallDuration=response?.data?.data[0]?.totalMemberCallDuration
        this.callReport.TotalMemberCallTransferDuration=response?.data?.data[0]?.totalMemberCallTransferDuration
        this.callReport.TotalMemberToDestinationDuration=response?.data?.data[0]?.totalMemberToDestinationDuration
        this.callReport.TotalQueueOperatorTransferDuration=response?.data?.data[0]?.totalQueueOperatorTransferDuration
        this.callReport.TotalQueueTransferDuration =response?.data?.data[0]?.totalQueueTransferDuration
        this.callReport.TotalSecretaryDuration=response?.data?.data[0]?.totalSecretaryDuration
        this.callReport.TotalTransferedByIvrDuration=response?.data?.data[0]?.totalTransferedByIvrDuration
        this.callReport.TotalTransferedByOutgoingCallDuration=response?.data?.data[0]?.totalTransferedByOutgoingCallDuration
        this.callReport.TotalTransferedBySecretaryDuration=response?.data?.data[0]?.totalTransferedBySecretaryDuration
        this.callReport.TotalVirtualToDestinationDuration=response?.data?.data[0]?.totalVirtualToDestinationDuration
        this.callReport.TotalVirtualToMemberDuration=response?.data?.data[0]?.totalVirtualToMemberDuration
        this.callReport.TotalVoiceMailDuration=response?.data?.data[0]?.totalVoiceMailDuration

        this.callReport.PageNumber = response?.data?.pageNumber;
        this.callReport.PageSize = response?.data?.pageSize;
        this.callReport.TotalCount = response?.data?.totalCount;

    }
}

